import urls from './urls'
import base from './base'

const post = async (content) =>{
    const result = await base.postMethod(urls.CONTACT,content)
    return result;
}

export default {post}